export const PLACEHOLDER_TEXTS = [
  'A golden retriever puppy bounding through a sun-drenched meadow, slow motion, cinematic warm tones',
  'A cozy coffee shop on a rainy evening, steam rising from a cup, soft bokeh lights in the background',
  'A futuristic city skyline at dusk, flying cars weaving between neon-lit towers, epic wide shot'
]
